<script>
import AccordionItemResearch from "./AccordionItemResearch";

export default {
  name: "AccordionResearch",
  components: { AccordionItemResearch },
  props: {
    content: Array,
    dataItem: Object,
  },
  data() {
    return {
      isMoreThenOne: false,
    };
  },
  computed: {
    checkLengthAddClass() {
      return this.isMoreThenOne;
    },
  },
  methods: {
    updateIsMoreThanOne() {
      this.isMoreThenOne = this.content.length >= 1;
    },
  },
  watch: {
    content: "updateIsMoreThanOne",
  },
};
</script>
<template>
  <div class="accordion box" role="presentation">
    <accordion-item-research
      v-for="item in content"
      :item="item"
      :key="item.id"
      :dataItem="dataItem"
      :class="checkLengthAddClass ? 'borders' : ''"
    >
    </accordion-item-research>
  </div>
</template>

<style lang="scss">
$radius: 13px;
.accordion {
  padding: 0;
}
.accordion-item {
  padding: 8.5px 0px;
  border-radius: var(--radius-second);
  border: solid 1px #e9e9eb;
  background-color: #fff;
  margin-bottom: 16px;
  &.active {
    .accordion-item-title {
      padding-bottom: 8px;
      border-bottom: 1px solid var(--grayscale-170);
    }
  }
}

.accordion-item-title {
  position: relative;
  padding: 0px 20px 0px 20px;
  border-bottom: 1px solid transparent;
}
.accordion-item-trigger {
  width: 100%;
  text-align: left;
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  h4 {
    font-size: 14px !important;
    font-weight: 600 !important;

    @media (max-width: 768px) {
      font-size: 12px !important;
    }
  }
}
.accordion-item-trigger-icon {
  $size: 8px;
  display: block;
  position: absolute;
  top: 50%;
  right: 23px;
  bottom: 0;
  margin: auto;
  width: $size;
  height: $size;
  border-right: 2px solid #363636;
  border-bottom: 2px solid #363636;
  transform: translateY(-50%) rotate(45deg);
  transition: transform 0.2s ease;
  .active & {
    transform: translateY(-50%) rotate(225deg);
  }
}
.accordion-item-details {
  overflow: hidden;
  padding: 0px 20px;
}
.accordion-item-details-inner {
  table {
    width: 100%;
    border: 1px solid var(--grayscale-20);
    border-radius: $radius;
    border-spacing: 0;
  }

  td {
    border-bottom: 1px solid var(--color-primary-tint-second);
    padding: 5px 20px;

    &:first-child {
      width: 20px;
      border-left: 1px solid var(--color-primary-tint-second);
    }
    &:last-child {
      border-right: 1px solid var(--color-primary-tint-second);
    }
  }
}
.accordion-item-enter-active,
.accordion-item-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.accordion-item-enter,
.accordion-item-leave-to {
  height: 0 !important;
}
.borders {
  tr {
    &:last-child > td {
      border-bottom: none;
    }

    &:first-child {
      td:first-child {
        border-top-left-radius: $radius;
      }
      td:last-child {
        border-top-right-radius: $radius;
      }
    }

    &:last-child {
      td:first-child {
        border-bottom-left-radius: $radius;
      }
      td:last-child {
        border-bottom-right-radius: $radius;
      }
    }
  }
}
</style>
